<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom Complet</span>
      </div>
      <input v-model="dataForm.nom_complet"
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom d'utilisateur</span>
      </div>
      <input v-model="dataForm.nom_utilisateur"
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Email</span>
      </div>
      <input v-model="dataForm.email"
             type="text"
             class="form-control">
    </div>
<!--
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Ancien mot de passe</span>
      </div>
      <input v-model="dataForm.mot_de_passe.slice(0,10)"
             disabled
             type="password"
             class="form-control"
             placeholder="Adresse email" >
    </div>
-->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Nouveau mot de passe</span>
      </div>
      <input v-model="dataForm.nouveau_mot_de_pass"
             type="password"
             class="form-control"
             placeholder="Adresse email" >
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    admin: {
      type: Object
    }
  },
  data(){
    return{
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom_complet: '',
        nom_utilisateur: '',
        email: '',
        mot_de_passe: '',
        nouveau_mot_de_pass: '',
        table: 'admin',
        table_id: this.admin.admin_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Admin modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification de l'admin !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification de l'admin !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.nom_complet === '')
        this.dataForm.nom_complet = this.admin.nom_complet
      if(this.dataForm.nom_utilisateur === '')
        this.dataForm.nom_utilisateur = this.admin.nom_utilisateur
      if(this.dataForm.email === '')
        this.dataForm.email = this.admin.email
      if(this.dataForm.mot_de_passe === '')
        this.dataForm.mot_de_passe = this.admin.mot_de_passe
      if(this.dataForm.nouveau_mot_de_pass !== '')
        this.dataForm.mot_de_passe = this.dataForm.nouveau_mot_de_pass
    },
    setDefaultValues() {
      const admin = Object.assign({}, this.admin);
      this.dataForm.nom_complet = admin.nom_complet
      this.dataForm.nom_utilisateur = admin.nom_utilisateur
      this.dataForm.email = admin.email
      this.dataForm.mot_de_passe = admin.mot_de_passe
    },
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    this.setDefaultValues()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/components/Update.vue